export default __webpack_public_path__ + "static/media/71d350b88423bc757b7d92b74ca14d08.jpg";